export default "__VITE_ASSET__cacc75cf__"